// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import { useLocation, useParams } from "react-router-dom";
// import CommitteeLandingPage from "./CommitteeLandingPage";
// import CommitteeDocumentPage from "./CommitteeDocumentPage";
// import CommitteeMemberPage from "./CommitteeMemberPage";
// import CommitteePostPage from "./CommitteePostPage";
// import CommitteeEventPage from "./CommitteeEventPage";
// import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";

// function CommitteeBannerContent() {
//   const { committeeID } = useParams();

//   const [activeTab, setActiveTab] = useState("home");
//   const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

//   const committeeHomePage = useSelector(
//     (x) => x?.committee?.getCommitteeHomePageIntegrationDataResponse?.data
//     // ?.committeeHomePage
//   );

//   // const getActiveTab = () => {
//   //   if (location.pathname === "/Committee") return "home";
//   //   if (location.pathname === "/Committee/Members") return "members";
//   //   if (location.pathname === "/Committee/Documents") return "document";

//   //   return "";
//   // };

//   // const activeTab = getActiveTab();
//   const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
//   const UserRole = localStorage.getItem("userRoleID");
//   const committees = JSON.parse(sessionStorage.getItem("committee_Id"));
//   return (
//     <>
//       <section
//         className="hero-section committee-banner"
//         style={{
//           backgroundImage: `url(${
//             ImageURL + committeeHomePage?.committeeBannerImage
//           })`,
//         }}
//       >
//         <div className="overlay"></div>
//         <div className="hero-content">
//           <h1 className="fw-bold display-5 mb-50">
//             {committeeHomePage?.committe?.committeeName}
//           </h1>
//           <div className="nav-buttons">
//             <div
//               className={`nav-button cursor-pointer ${
//                 activeTab === "home" ? "active" : ""
//               }`}
//               onClick={() => {
//                 setActiveTab("home");
//               }}
//             >
//               <i className="bi bi-house-fill"></i>
//               <span className="d-sm-block d-none">Home</span>
//             </div>

//             <div
//               // className={`nav-button ${
//               //   activeTab === "document" ? "active" : ""
//               // } ${!isLoggedIn ? "disabled" : ""}`}
//               className={`nav-button ${
//                 activeTab === "document" ? "active" : ""
//               } ${
//                 !isLoggedIn ||
//                 !(
//                   UserRole === "3" ||
//                   ((UserRole === "1" || UserRole === "2") &&
//                     committees?.some(
//                       (val) => String(val) === String(committeeID)
//                     ))
//                 )
//                   ? "disabled"
//                   : ""
//               }`}
//               onClick={() => {
//                 if (isLoggedIn) {
//                   setActiveTab("document");
//                 } else {
//                   showToastNotification(
//                     "Please log in to access Documents.",
//                     "error"
//                   );
//                 }
//               }}
//             >
//               <i className="bi bi-file-earmark-text"></i> Documents
//             </div>

//             <div
//               // className={`nav-button ${
//               //   activeTab === "calender" ? "active" : ""
//               // } ${!isLoggedIn ? "disabled" : ""}`}
//               className={`nav-button ${
//                 activeTab === "calender" ? "active" : ""
//               } ${
//                 !isLoggedIn ||
//                 !(
//                   UserRole === "3" ||
//                   ((UserRole === "1" || UserRole === "2") &&
//                     committees?.some(
//                       (val) => String(val) === String(committeeID)
//                     ))
//                 )
//                   ? "disabled"
//                   : ""
//               }`}
//               onClick={() => {
//                 if (isLoggedIn) {
//                   setActiveTab("calender");
//                 } else {
//                   showToastNotification(
//                     "Please log in to access Calendar.",
//                     "error"
//                   );
//                 }
//               }}
//             >
//               <i className="bi bi-calendar3"></i> Calendar
//             </div>

//             <div
//               // className={`nav-button ${activeTab === "post" ? "active" : ""} ${
//               //   !isLoggedIn ? "disabled" : ""
//               // }`}
//               className={`nav-button ${activeTab === "post" ? "active" : ""} ${
//                 !isLoggedIn ||
//                 !(
//                   UserRole === "3" ||
//                   ((UserRole === "1" || UserRole === "2") &&
//                     committees?.some(
//                       (val) => String(val) === String(committeeID)
//                     ))
//                 )
//                   ? "disabled"
//                   : ""
//               }`}
//               onClick={() => {
//                 if (isLoggedIn) {
//                   setActiveTab("post");
//                 } else {
//                   showToastNotification(
//                     "Please log in to access Posts.",
//                     "error"
//                   );
//                 }
//               }}
//             >
//               <i className="bi bi-chat-left-dots-fill"></i> Posts
//             </div>

//             {/* <div
//               className={`nav-button cursor-pointer ${activeTab === "document" ? "active" : ""
//                 }`}
//               // onClick={(e) => e.preventDefault()}
//               onClick={() => {
//                 setActiveTab("document");
//               }}
//             >
//               <i className="bi bi-file-earmark-text"></i> Documents
//             </div>

//             <div
//               className={`nav-button cursor-pointer ${activeTab === "post" ? "active" : ""
//                 }`}
//               onClick={() => {
//                 setActiveTab("post");
//               }}
//             >
//               <i className="bi bi-chat-left-dots-fill"></i> Posts
//             </div> */}

//             <div
//               // className={`nav-button cursor-pointer ${
//               //   activeTab === "members" ? "active" : ""
//               // }`}
//               className={`nav-button ${
//                 activeTab === "members" ? "active" : ""
//               } ${
//                 !isLoggedIn ||
//                 !(
//                   UserRole === "3" ||
//                   ((UserRole === "1" || UserRole === "2") &&
//                     committees?.some(
//                       (val) => String(val) === String(committeeID)
//                     ))
//                 )
//                   ? "disabled"
//                   : ""
//               }`}
//               onClick={() => {
//                 setActiveTab("members");
//               }}
//             >
//               <i className="bi bi-people-fill"></i> Members
//             </div>
//           </div>
//         </div>
//       </section>

//       {activeTab === "home" && <CommitteeLandingPage />}
//       {activeTab === "document" && <CommitteeDocumentPage />}
//       {activeTab === "calender" && <CommitteeEventPage />}
//       {activeTab === "members" && <CommitteeMemberPage />}
//       {activeTab === "post" && <CommitteePostPage />}
//     </>
//   );
// }

// export default CommitteeBannerContent;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import CommitteeLandingPage from "./CommitteeLandingPage";
import CommitteeDocumentPage from "./CommitteeDocumentPage";
import CommitteeMemberPage from "./CommitteeMemberPage";
import CommitteePostPage from "./CommitteePostPage";
import CommitteeEventPage from "./CommitteeEventPage";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import { committeeActions } from "../../../_store/committee.slice";

function CommitteeBannerContent() {
  const dispatch = useDispatch();
  const { committeeID } = useParams();
  const { state } = useLocation();
  const [activeTab, setActiveTab] = useState("home");
  const [committeeBannerURL, setCommitteeBannerURL] = useState("");
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  const committeeHomePage = useSelector(
    (x) => x?.committee?.getCommitteeHomePageIntegrationDataResponse?.data
  );
  const committeeData = state?.committeeID;

  useEffect(() => {
    if (!committeeID) return;
    dispatch(committeeActions?.getCommitteeHomePageIntegrationData(committeeID))
      .then((result) => {
        // console.log(result?.payload?.data?.committeeBannerImage);
        setCommitteeBannerURL(result?.payload?.data?.committeeBannerImage);
      })
      .catch((err) => {});
    dispatch(committeeActions?.setCommittieID(committeeData));
  }, [committeeID]);

  const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
  const UserRole = sessionStorage.getItem("userRoleID");

  let committees;
  const storedCommittees = sessionStorage.getItem("committee_Id");

  if (storedCommittees && storedCommittees !== "undefined") {
    committees = JSON.parse(storedCommittees);
  } else {
    committees = []; // or null, depending on your use case
  }

  // Common function to check if a nav button should be enabled
  const isButtonEnabled = () => {
    return (
      isLoggedIn &&
      (UserRole === "3" ||
        ((UserRole === "1" || UserRole === "2") &&
          committees?.some((val) => String(val?._id) === String(committeeID))))
      // committees?.some((val) => String(val) === String(committeeID))))
    );
  };

  // Common function to handle button clicks
  const handleNavClick = (tabName, featureName) => {
    if (!isLoggedIn) {
      showToastNotification(
        `Get involved and register to get full access`,
        "error"
      );
    } else if (!isButtonEnabled()) {
      showToastNotification(
        `Get involved and register to get full access`,
        "error"
      );
    } else {
      setActiveTab(tabName);
    }
  };

  console.log(ImageURL + committeeBannerURL);

  return (
    <>
      <div className="mobile-view-text d-block d-sm-none text-center bg-warning p-2">
        This page is best viewed in landscape/horizontal view
      </div>
      <section
        className="hero-section committee-banner ddd"
        // style={{
        //   backgroundImage: `url(${
        //     ImageURL + committeeHomePage?.committeeBannerImage
        //   })`,
        // }}
        style={
          committeeBannerURL
            ? {
                // backgroundImage: `url(${ImageURL + committeeBannerURL})`,
                backgroundImage: `url("${ImageURL + committeeBannerURL}")`,
              }
            : { backgroundColor: "fff" }
        }
      >
        <div className="overlay"></div>
        <div className="hero-content">
          <h1 className="fw-bold display-5 mb-50">
            {committeeHomePage?.committe?.committeeName}
          </h1>
          <div className="nav-buttons">
            <div
              className={`nav-button cursor-pointer ${
                activeTab === "home" ? "active" : ""
              }`}
              onClick={() => setActiveTab("home")}
            >
              <i className="bi bi-house-fill"></i>
              {/* <span className="d-sm-block d-none">Home</span> */}
              <span className="d-sm-block ">Home</span>
            </div>

            {["document", "calendar", "posts", "members"].map((tab) => (
              <div
                key={tab}
                className={`nav-button ${activeTab === tab ? "active" : ""} ${
                  !isButtonEnabled()
                    ? "disabled cursor-nodrop"
                    : "cursor-pointer"
                }`}
                onClick={() =>
                  handleNavClick(
                    tab,
                    tab.charAt(0).toUpperCase() + tab.slice(1) // Capitalize for feature name
                  )
                }
              >
                <i
                  className={`bi ${
                    tab === "document"
                      ? "bi-file-earmark-text"
                      : tab === "calender"
                      ? "bi-calendar3"
                      : tab === "posts"
                      ? "bi-chat-left-dots-fill"
                      : "bi-people-fill"
                  }`}
                ></i>{" "}
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </div>
            ))}
          </div>
        </div>
      </section>

      {activeTab === "home" && <CommitteeLandingPage />}
      {activeTab === "document" && <CommitteeDocumentPage />}
      {activeTab === "calendar" && <CommitteeEventPage />}
      {activeTab === "members" && <CommitteeMemberPage />}
      {activeTab === "posts" && <CommitteePostPage />}
    </>
  );
}

export default CommitteeBannerContent;
